export default "__VITE_ASSET__afa01e7e__"